import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import CompanyLogo from "./../../../Images/comlogo.png";
import Slider from "react-slick";
import "./GroupCompanies.css"
import { Container, Row, Col } from "react-bootstrap";

function GroupCompanies(props) {
    const [dataExchange, setExchangeData] = useState("nse");
    const location = useLocation();
    //const { exchg, cocode } = useParams();
    const [data, setData] = useState([]);
    const [dataName, setDataName] = useState([]);
    const [exchange, setexchange] = useState(['']);
    let getcompname, getData, getDataName, dataCount;
    const childRef = useRef(null);
    const { BaseURL } = useContext(URLstateContext);
    let exchg = props.exchange;
    let cocode = props.coCode;
    useEffect(() => {
        const getUrl = BaseURL + "GroupCompanies";
        const getUrlName = BaseURL + "GroupCompaniesName";
        if (cocode != "") {
            fetch(`${getUrl}/${cocode}/20`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log("data", data);
                })
                .catch((error) => {
                    // console.log("not found the api 1233333");
                });

            fetch(`${getUrlName}/${cocode}`)
                .then((response) => response.json())
                .then((dataName) => {
                    getDataName = dataName.data;
                    setDataName(getDataName);
                    // console.log("data1", dataName);
                })
                .catch((error) => {
                    // console.log("not found the api 1233333");
                });
            let widthWindow = window.matchMedia("(max-width: 450px)")
            if (widthWindow.matches) {
                setTimeout(() => {
                    let sliderBtn = document.getElementsByClassName('slick-dots');
                    // console.log(sliderBtn[1]);
                    sliderBtn[0].firstChild.firstChild.click();
                }, 2000)
            }
        }



    }, [props.exchange, props.coCode]);

    //    fetch(`${getUrlName}/${cocode}`)
    //        .then((response) => response.json())
    //        .then((dataName) => {
    //            getDataName = dataName.data;
    //            setDataName(getDataName);
    //            // console.log("data1", dataName);
    //        })
    //        .catch((error) => {
    //           // console.log("not found the api 1233333");
    //        });





    //        setTimeout(() => {
    //            let sliderBtn = document.getElementsByClassName('slick-dots');
    //            // console.log(sliderBtn[1]);
    //            sliderBtn[0].firstChild.firstChild.click();
    //          }, 3000)

    //}, []);



    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                }
            },
            {
                breakpoint: 767,

                settings: {
                    slidesToShow: 2,
                    infinite: false,
                    slidesToScroll: 2,
                    initialSlide: 1,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    initialSlide: 1,
                },
            },
        ],
    };


    return (
        <section className="Group-Companies-block">
            <Container className="table-boxGroup">
                <Row>
                    <Col lg={12} md={12} sm={12}>
                        {dataName != null &&
                            dataName.map(
                                ({ HSE_L_NAME }) => (
                                    <div>
                                        <h3 className="mainHeadingGroup"> {HSE_L_NAME} Group Companies</h3>
                                        <span> Track the {data != null && data.length} companies of {HSE_L_NAME} Group </span><br></br><br></br>
                                    </div>
                                )
                            )}
                        {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                        <Slider {...settings} id="demo">
                            {data &&
                                data.map(
                                    ({ co_code, sc_name, PRICE, changeperc, CurrMCAP, Pricediff }) => (
                                        <div key={co_code} className="each-equity">
                                            <div className="each-equity-inner">
                                                <div className="each-equity-alpha">
                                                    <img src={CompanyLogo} alt="CompanyLogo-img" />
                                                </div>
                                                <div className="each-equity-beta">
                                                    <div className="nameGroup">
                                                        <h4>{sc_name}</h4>
                                                    </div>
                                                    <div className="no-gutters">
                                                        <div className="col-4 compess">
                                                            <small><strong>Share Price</strong></small>
                                                            <p> ₹ {PRICE != null ? PRICE : 0}
                                                                <span className={Pricediff.toFixed(2) > 0 ? "textGreen" : "textRed"}> {Pricediff != null ? Pricediff.toFixed(2) : 0}</span>
                                                                <span className={changeperc.toFixed(2) > 0 ? "textGreen" : "textRed"}> {changeperc != null ? ("(" + changeperc.toFixed(2) + "%)") : 0}</span>
                                                            </p>
                                                        </div>
                                                        <div className="col-4 compess">
                                                            <small><strong>CurrMCAP</strong></small>
                                                            <p> {CurrMCAP != null ? CurrMCAP.toFixed(2) : 0}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default GroupCompanies